<div class="govuk-grid-row">
  <div class="govuk-grid-column-two-thirds-from-desktop">
    <h1 class="govuk-heading-l">Page not found</h1>
    <p>If you typed the web address, check it is correct.</p>
    <p>If you pasted the web address, check you copied the entire address.</p>
    <p>If you think the address is correct, let us know.</p>
    <p><a [routerLink]="['/dashboard']" class="text-link">Return to the homepage</a></p>
  </div>
</div>
